// Components==============
import React from 'react';
import { useSelector } from 'react-redux';
import CheatSheetBox from './CheatSheetBox/CheatSheetBox';
import CheatSheetPlayer from './CheatSheetPlayer/CheatSheetPlayer';
// =========================

export default function Back({
    setVideo,
}: {
    setVideo: (videoIdProp: string) => void;
}) {
    const treatmentsForVideo = useSelector(
        (state: ReduxStore) =>
            state.authentication?.user?.progress?.treatments || []
    );

    return (
        <>
            <CheatSheetBox back text="Weetwoorden">
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('9943beb04bf5ed83e067437db100caf6');
                    }}
                    enabled={treatmentsForVideo.includes(49)}
                    audioFile="/audio/spiekbrief/teit-en-tijd.mp3"
                    text={<p>-teit of -tijd</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('d459b9f455f5196581e68f8f23eeff63');
                    }}
                    enabled={treatmentsForVideo.includes(51)}
                    audioFile="/audio/spiekbrief/papegaai.mp3"
                    text={<p>papegaai</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('058ae444f9ecbdb7d11ef78677517d66');
                    }}
                    enabled={treatmentsForVideo.includes(52)}
                    audioFile="/audio/spiekbrief/circus.mp3"
                    text={<p>circus</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('01355304b6a77b9dda0a6f0fdad7667b');
                    }}
                    enabled={treatmentsForVideo.includes(53)}
                    audioFile="/audio/spiekbrief/bagage.mp3"
                    text={<p>bagage</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('7bf73398b84c59f529bcc0eeff132a8b');
                    }}
                    enabled={treatmentsForVideo.includes(54)}
                    audioFile="/audio/spiekbrief/chimpansee.mp3"
                    text={<p>chimpansee</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('827f6be6005ccc7f2a19713c6dde18be');
                    }}
                    enabled={treatmentsForVideo.includes(55)}
                    audioFile="/audio/spiekbrief/militair-punaise.mp3"
                    text={<p>militair,punaise</p>}
                />
            </CheatSheetBox>
            <CheatSheetBox back text="Regelwoorden">
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('f423b17ec294910c9fa48949072bf1ed');
                    }}
                    enabled={treatmentsForVideo.includes(26)}
                    audioFile="/audio/spiekbrief/lange-klankenregel.mp3"
                    text={<p>Lange klankenregel</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('f6b3a40207bf0278c11e4b2be4303097');
                    }}
                    enabled={treatmentsForVideo.includes(29)}
                    audioFile="/audio/spiekbrief/korte-klankenregel.mp3"
                    text={<p>Korte klankenregel</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('39c7f78fdae8f79fd1a5659516fb7401');
                    }}
                    enabled={treatmentsForVideo.includes(37)}
                    audioFile="/audio/spiekbrief/boeven-roven-sloffen.mp3"
                    text={<p>boeven roven sloffen</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('3daecdad94009519bd4080647bdec87b');
                    }}
                    enabled={treatmentsForVideo.includes(39)}
                    audioFile="/audio/spiekbrief/17.mp3"
                    text={<p>muizen lezen lessen</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('56ae416eb39a81fb9a15c1712390c962');
                    }}
                    enabled={treatmentsForVideo.includes(46)}
                    audioFile="/audio/spiekbrief/18.mp3"
                    text={<p>drie kilo piepers in een taxi</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('dca22e495eccdc02a9eea5d4974084c7');
                    }}
                    enabled={treatmentsForVideo.includes(47)}
                    audioFile="/audio/spiekbrief/19.mp3"
                    text={<p>panda's</p>}
                />
            </CheatSheetBox>
            <CheatSheetBox back text="Bijna wat ik hoor">
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('41943c6b2dc062d4f3d17f0a1100aad5');
                    }}
                    enabled={treatmentsForVideo.includes(16)}
                    audioFile="/audio/spiekbrief/12.mp3"
                    text={<p>-je -tje -pje</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('d8b150f5eb009230afaed273e1ed6873');
                    }}
                    enabled={treatmentsForVideo.includes(27)}
                    audioFile="/audio/spiekbrief/13.mp3"
                    text={<p>be- ge- ver-</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('0c1cc8815ce94bc675729f1b7277e235');
                    }}
                    enabled={treatmentsForVideo.includes(28)}
                    audioFile="/audio/spiekbrief/14.mp3"
                    text={<p>-e -el -erd -er -en</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('e724968f90297ba9494468bbed902b3b');
                    }}
                    enabled={treatmentsForVideo.includes(35)}
                    audioFile="/audio/spiekbrief/15.mp3"
                    text={<p>-ig -lijk</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('1d3151f660c918b0e50de5a7b5bf7c09');
                    }}
                    enabled={treatmentsForVideo.includes(36)}
                    audioFile="/audio/spiekbrief/20.mp3"
                    text={<p>-eren -oren -euren</p>}
                />
                <CheatSheetPlayer
                    onClick={() => {
                        setVideo('31e49b374e7645342cf8440fa4b6b97e');
                    }}
                    enabled={treatmentsForVideo.includes(42)}
                    audioFile="/audio/spiekbrief/21.mp3"
                    text={<p>-tie -isch -heid</p>}
                />
            </CheatSheetBox>
        </>
    );
}
